export default __webpack_public_path__ + "static/screeny-150-gpz-unica-5-35bdff1f16e3d472b9aeb97a752f5b07.jpg";